module.exports = __webpack_public_path__ + "assets/img/73ef8a84dbd76170447a162cdf032fb1.svg";